






























































































































































import { Component, Vue } from 'vue-property-decorator';
import { IMNO, IMNOSender, ISender } from '@/interfaces';
import {
  readMNOs,
  dispatchGetMNOs,
  dispatchUpdateMNO,
  dispatchCreateMNO,
  readMNOSenders,
  dispatchGetMNOSenders,
  dispatchGetSenders,
  readSenders,
  dispatchCreateMNOSender,
  dispatchUpdateMNOSender,
  dispatchDeleteMNOSenders,
} from '@/store/admin/accessors';
import { ValidationProvider } from 'vee-validate';

@Component
export default class MNOs extends Vue {
  public dialog: boolean = false;
  public mnoSenderDialog: boolean = false;

  public id: number = 0;
  public name: string = '';
  public originalName: string | null = '';
  public gateway: string | null = '';

  public mnoSenderId: number = 0;
  public mnoSenderGateway: string = '';
  public senderId: number | null = null;
  public mnoSenderValid: boolean = false;

  public senders: ISender[] = [];

  public headers = [
    {
      text: this.$vuetify.lang.t('$vuetify.name'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.originalName'),
      sortable: true,
      value: 'original_name',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.gateway'),
      sortable: true,
      value: 'gateway',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.actions'),
      value: 'id',
    },
  ];

  public mnoSendersHeaders = [
    {
      text: this.$vuetify.lang.t('$vuetify.sender'),
      sortable: true,
      value: 'sender',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.gateway'),
      sortable: true,
      value: 'gateway',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.actions'),
      value: 'id',
    },
  ];

  public $refs!: {
    mnoSenderObserver: InstanceType<typeof ValidationProvider>;
  };

  get mnos() {
    return readMNOs(this.$store);
  }

  get mnoSenders() {
    return readMNOSenders(this.$store);
  }

  public async mounted() {
    await dispatchGetMNOs(this.$store);
    await dispatchGetSenders(this.$store);
    this.senders = readSenders(this.$store);
  }

  public async edit(mno: IMNO) {
    this.id = mno.id;
    this.name = mno.name;
    this.originalName = mno.original_name;
    this.gateway = mno.gateway;
    await dispatchGetMNOSenders(this.$store, this.id);
    this.dialog = true;
  }

  public async updateMNOSender(mnoSender: IMNOSender) {
    this.mnoSenderId = mnoSender.id;
    this.senderId = mnoSender.sender_id;
    this.mnoSenderGateway = mnoSender.gateway;
    this.mnoSenderDialog = true;
    if (this.$refs.mnoSenderObserver) {
      this.$refs.mnoSenderObserver.reset();
    }
  }

  public async deleteMNOSender(mnoSender: IMNOSender) {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteMNOSendersConfirmation'))) {
      await dispatchDeleteMNOSenders(this.$store, { mnoId: this.id, ids: [mnoSender.id] });
      await dispatchGetMNOSenders(this.$store, this.id);
    }
  }

  public add() {
    this.id = 0;
    this.name = '';
    this.originalName = '';
    this.gateway = '';
    this.dialog = true;
  }

  public createMNOSender() {
    this.mnoSenderId = 0;
    this.mnoSenderGateway = '';
    this.senderId = null;
    this.mnoSenderDialog = true;
    if (this.$refs.mnoSenderObserver) {
      this.$refs.mnoSenderObserver.reset();
    }
  }

  public close() {
    this.dialog = false;
  }

  public closeMNOSender() {
    this.mnoSenderDialog = false;
  }

  public async save() {
    if (!this.id) {
      await dispatchCreateMNO(this.$store, {
        name: this.name,
        original_name: this.originalName || null,
        gateway: this.gateway || null,
      });
    } else {
      await dispatchUpdateMNO(this.$store, {
        id: this.id,
        mno: { name: this.name, original_name: this.originalName || null, gateway: this.gateway || null },
      });
    }
    await dispatchGetMNOs(this.$store);
    this.close();
  }

  public async saveMNOSender() {
    if (await this.$refs.mnoSenderObserver.validate() && this.senderId) {
      let result: boolean;
      if (!this.mnoSenderId) {
        result = await dispatchCreateMNOSender(this.$store, {
          mnoId: this.id,
          data: { sender_id: this.senderId, gateway: this.mnoSenderGateway },
        });
      } else {
        result = await dispatchUpdateMNOSender(this.$store, {
          id: this.mnoSenderId,
          mnoId: this.id,
          data: { sender_id: this.senderId, gateway: this.mnoSenderGateway },
        });
      }
      if (result) {
        await dispatchGetMNOSenders(this.$store, this.id);
        this.closeMNOSender();
      }
    }
  }
}
